import { Store } from '@betgames/bg-state-manager';
import { ISoundsModel } from './interfaces';

export default class SoundsStore extends Store<ISoundsModel> {
    constructor() {
        super({
            key: 'Sounds',
            default: {
                studioSoundsMuted: true,
                gameSoundsMuted: true,
                backgroundMusicMuted: true,
            },
        });
    }

    public get studioSoundsMuted(): boolean {
        return this.value.studioSoundsMuted;
    }

    public set studioSoundsMuted(value: boolean) {
        this.update((draft) => {
            draft.studioSoundsMuted = value;
        });
    }

    public get gameSoundsMuted(): boolean {
        return this.value.gameSoundsMuted;
    }

    public set gameSoundsMuted(value: boolean) {
        this.update((draft) => {
            draft.gameSoundsMuted = value;
        });
    }

    public get backgroundMusicMuted(): boolean {
        return this.value.backgroundMusicMuted;
    }

    public set backgroundMusicMuted(value: boolean) {
        this.update((draft) => {
            draft.backgroundMusicMuted = value;
        });
    }

    public setMasterMuted(value: boolean): void {
        this.update((draft) => {
            draft.studioSoundsMuted = value;
            draft.gameSoundsMuted = value;
            draft.backgroundMusicMuted = value;
        });
    }
}

export const soundsStore = new SoundsStore();
